import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, HostListener } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthTransmissionService } from '../../../services/raintree/Transmission/auth-transmission.service';
import {
  RaintreeResponse,
  SendMobileOTPResponse,
} from '../../../services/raintree/interfaces/raintree-response';
import { SnackbarService } from '../../../services/common/snackbar.service';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { AuthService } from '../../../services/auth/auth-service';
import { RequestMapper } from '../../../request-mapper';
import { CanComponentDeactivate } from '../../../guard/unsaved-changes.guard';
import { AppConfigService } from '../../../services/config/app-config.service';

@Component({
  selector: 'app-login-verify',
  standalone: true,
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    MatAutocompleteModule,
  ],
  templateUrl: './login-verify.component.html',
  styleUrl: './login-verify.component.scss',
})
export class LoginVerifyComponent  {
  constructor(
    private _authTransmissionService: AuthTransmissionService,
    private snackbar: SnackbarService,
    private activateRoute: ActivatedRoute,
    private _commonUtilService: CommonUtilService,
    private _authService: AuthService,
    private _router: Router,
    private _apppConfig: AppConfigService
  ) {}

  authenticationCodeVisible = false;
  visibilityOnIcon = '--pass-visibility-on';
  visibilityOffIcon = '--pass-visibility-off';
  maskedNo: any;
  sessionId2: any;
  sessionId1: any;
  familyCode: any;
  phlMemCode: any;
  memName: any;
  memSurname: any;
  loginFormPayload: any;

  loginVerifyForm = new FormGroup({
    authenticationCode: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
  });
 
  ngOnInit(): void {
    this.startCountdownForMobile();
    this.maskedNo = localStorage.getItem('maskedNumber');
    this.sessionId2 = localStorage.getItem('session2Id');
    this.sessionId1 = localStorage.getItem('sessionId');
    this.familyCode = localStorage.getItem('familyCode');
    this.phlMemCode = localStorage.getItem('phlMemCode');
    this.memName = localStorage.getItem('memName');
    this.memSurname = localStorage.getItem('memName');
    // if (
    //   !this.maskedNo ||
    //   !this.sessionId2 ||
    //   !this.sessionId1 ||
    //   !this.familyCode ||
    //   !this.phlMemCode ||
    //   !this.memName ||
    //   !this.memSurname
    // ) {
    //   this._router.navigate(['/login']);
    // }

    // this.activateRoute.queryParams.subscribe((params) => {
    //   this.maskedNo = params['maskedNumber'] ? params['maskedNumber'] : null;
    //   this.sessionId2 = params['session2Id'] ? params['session2Id'] : null;
    //   this.sessionId1 = params['sessionId'] ? params['sessionId'] : null;
    //   this.familyCode = params['familyCode'] ? params['familyCode'] : null;
    //   this.phlMemCode = params['phlMemCode'] ? params['phlMemCode'] : null;
    //   this.memName = params['memName'] ? params['memName'] : null;
    //   this.memSurname = params['memSurname'] ? params['memSurname'] : null;
    // });
    console.log('hgghgh', this.maskedNo);
    console.log('hgghgh', this.memName);
    console.log('session2id', this.sessionId2);
  }
 

  onInputBlur(field: string) {
    if (field === 'password') {
      this.authenticationCodeVisible =
        this.loginVerifyForm.controls.authenticationCode.invalid;
    }
  }
  toggleauthCodeVisibility() {
    this.authenticationCodeVisible = !this.authenticationCodeVisible;
  }
  isSpanDisabledForMobile = true;
  countdownForMobile = 180;
  countdownIntervalForMobile: any;
  mobilePayload: any;

  onResendForMobile(): void {
    this.resendMobileOtp();
    this.isSpanDisabledForMobile = true;
    this.countdownForMobile = 180; // Reset countdown
    this.startCountdownForMobile();
  }
  startCountdownForMobile(): void {
    this.countdownIntervalForMobile = setInterval(() => {
      if (this.countdownForMobile > 0) {
        this.countdownForMobile--;
      } else {
        this.isSpanDisabledForMobile = false;
        clearInterval(this.countdownIntervalForMobile);
      }
    }, 1000);
  }
  counter: number = 0;
  resendMobileOtp() {
    this.counter++;
    let loginFormPayload = {
      sessionId: this.sessionId1,
      familyCode: this.familyCode,
      phlMemCode: this.phlMemCode,
      memName: this.memName,
      memSurname: this.memSurname,
    };

    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: (response: RaintreeResponse) => {
        this.sessionId2 = response['data'].session2Id;
      },
      error: (error) => {
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
  requireFc: any;
  requiredVerifiedEmail: any;
  secondAPIcall() {
    let loginFormPayload = {
      session2Id: this.sessionId2,
      otpValue: this.loginVerifyForm.get('authenticationCode')?.value,
    };

    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: (response: RaintreeResponse) => {
        this.requiredVerifiedEmail = response['data'].requiredVerifiedEmail;
        if (
          this._commonUtilService.isValidObject(response) &&
          response.hasOwnProperty('data') &&
          this._commonUtilService.getValidData(response['data'].accessToken)
        ) {
          // SAVE Token and helping local strorage data
          this._authService.storeJwtTokenInLocalStorage(response['data']);

          // Redirect to landing page
          this._router.navigate([this._apppConfig.getLadingRoute()]);
        } else if (this.requiredVerifiedEmail) {
          response['data'].linkedAccounts.forEach((elm: any) => {
            localStorage.setItem('familyCode', response['data'].familyCode);
            localStorage.setItem('sessionId', response['data'].sessionId);
            localStorage.setItem(
              'linkedAccounts',
              JSON.stringify(response['data'].linkedAccounts)
            );
            this._router.navigate(['/login-role-merge']);
          });
        }
      },
      error: (error) => {
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
}
